import { transformFanficData, type FanficDisplay } from '../transform-fanfic-data.util';

/** Maps raw SSR/API fanfics to the grid display shape (empty list for non-arrays). */
export const mapRawFanficsToDisplay = (rawFanfics: FanficDisplay[] | undefined): FanficDisplay[] =>
  Array.isArray(rawFanfics) ? rawFanfics.map(transformFanficData) : [];
